/* Luxury slideshow changes: restart premium text animation on every Dawn slide change. */
(() => {
  const activeClass = 'is-luxury-active';
  const animatedClass = 'is-luxury-animating';

  function syncLuxurySlide(slideshow) {
    const slides = slideshow.querySelectorAll('.slideshow__slide');
    slides.forEach((slide) => {
      const isActive = slide.getAttribute('aria-hidden') === 'false';
      slide.classList.toggle(activeClass, isActive);

      const text = slide.querySelector('.slideshow__text');
      if (!text) return;

      text.classList.remove(animatedClass);
      if (isActive) {
        window.requestAnimationFrame(() => {
          text.classList.add(animatedClass);
        });
      }
    });
  }

  function initLuxurySlideshows(root = document) {
    root.querySelectorAll('slideshow-component .slideshow--luxury-fade').forEach((slider) => {
      const component = slider.closest('slideshow-component');
      if (!component || component.dataset.luxurySlideshowReady === 'true') return;

      component.dataset.luxurySlideshowReady = 'true';
      syncLuxurySlide(component);

      component.addEventListener('slideChanged', () => {
        window.requestAnimationFrame(() => syncLuxurySlide(component));
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => initLuxurySlideshows());
  document.addEventListener('shopify:section:load', (event) => initLuxurySlideshows(event.target));
})();
/* End luxury slideshow changes. */